/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useLazyQuery, gql } from '@apollo/client';


export const usePooledAccountCreateRes = () => {
  const POOLED_ACCOUNT_CREATE_RES_GQL = gql`
  query PooledAccountCreateRes($userDetails: UserDetailsRequest!) {
  pooledAccountCreateRes(userDetails: $userDetails) {
    pooledAccountCreateRes {
      pooledAccountCreateRes
      userdetails {
        address1
        address2
        address3
        city
        country
        dasAccountNum
        dasAccountType
        dasBranchNum
        dateOfBirth
        email
        firstName
        intendedUse
        langId
        lastName
        middleName
        occupation
        phone
        state
        zipCode
        userId
        correspondenceVariant
      }
    }
  }
}
  `;

  const [ callPooledCreateRes, PooledResponse] = useLazyQuery(POOLED_ACCOUNT_CREATE_RES_GQL,
    {
       context:{
            clientName:"/secure-storage/manage"
        }
    }
  )

  return { callPooledCreateRes, PooledResponse }
}

